import { select, put } from 'redux-saga/effects'

import { track as trackEvent } from '../../actions/tracking'
import { setProductInfoDrawerClose } from '../../actions/ux'
import { selectProduct } from '../../selectors/product'
import { selectCurrentCollectionIndex } from '../../selectors/ux'

function* onProductInfoDrawerClose(action) {
  const { params: { productId, to } } = action.payload
  const product = yield select(selectProduct(productId))
  const position = (yield select(selectCurrentCollectionIndex)) + 1

  yield put(setProductInfoDrawerClose())

  yield put(trackEvent({
    event: 'closeDetail',
    params: {
      id: product.id,
      title: product.title,
      position,
      to,
    },
  }))
}

export default onProductInfoDrawerClose
